import React, { createContext, useCallback, useContext, useState } from 'react'

const ToastContext = createContext(undefined)

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([])

    const remove = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id))
    }, [])

    const show = useCallback((message, variant = 'info', timeoutMs = 2500) => {
        const id = Math.random().toString(36).slice(2)
        setToasts((prev) => [...prev, { id, message, variant }])
        if (timeoutMs > 0) {
            setTimeout(() => remove(id), timeoutMs)
        }
    }, [remove])

    return (
        <ToastContext.Provider value={{ show }}>
            {children}
            {/* 중앙 토스트 — 일반 모달(z-60~9999)보다 위에 두어 __silent+409 등 인터셉터 토스트가 가려지지 않게 함 */}
            <div className="fixed inset-0 z-[10050] flex items-center justify-center pointer-events-none">
                <div className="space-y-2 px-4 w-full max-w-md">
                    {toasts.map((t) => (
                        <div
                            key={t.id}
                            className={`pointer-events-auto rounded px-4 py-3 text-sm shadow-lg border bg-white/95 backdrop-blur ${t.variant === 'error' ? 'border-red-300 text-red-700' : t.variant === 'success' ? 'border-green-300 text-green-700' : 'border-slate-300 text-slate-700'}`}
                        >
                            {t.message}
                        </div>
                    ))}
                </div>
            </div>
        </ToastContext.Provider>
    )
}

export function useToast() {
    const ctx = useContext(ToastContext)
    if (!ctx) throw new Error('useToast must be used within ToastProvider')
    return ctx
}


